import { Fragment } from "react";
import { CardBody, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import NotesSection from "../../../components/Sections/Notes";
import AttachmentsSection from "../../../components/Sections/Attachments";
import { useSettings } from "../../../../../context/settings";
import { Field, SectionCard } from "../../../components/Record";
import { formatMinutes, personName, printPriority, printTaskStatus } from "../../../utils/helpers";

function OverviewTab({ taskData }) {
  const { t } = useTranslation();
  const { formatDate, formatDateTime } = useSettings();

  const customer = taskData?.customer;
  const customerName = customer?.company_name || personName(customer);

  return (
    <Fragment>
      <SectionCard
        id="task-informations-card"
        icon={<IoCheckmarkCircleOutline size={15} />}
        title={t('crm.taskInformationsSection')}
      >
        <CardBody>
          <Row className="g-3">
            <Field label={t('common.subject')} value={taskData?.subject} />
            <Field label={t('common.status')}>
              {printTaskStatus(taskData?.status || 'not_started')}
            </Field>
            <Field label={t('crm.priority')}>
              {printPriority(taskData?.priority) || <div className="crm-record-value">-</div>}
            </Field>
            <Field label={t('crm.assignedTo')} value={personName(taskData?.assigned_to)} />
            <Field label={t('sales.dueDate')} value={taskData?.due_date ? formatDate(taskData.due_date) : null} />
            <Field label={t('crm.reminder')} value={formatMinutes(taskData?.remind_before)} />
            <Field label={t('crm.customer')}>
              {customer?.id ? (
                <Link
                  to={"/crm/customers/view/" + customer.id}
                  state={{ customerData: customer }}
                  className="crm-record-value text-decoration-none"
                >
                  {customerName}
                </Link>
              ) : taskData?.lead_id ? (
                <Link to={"/crm/leads/view/" + taskData.lead_id} className="crm-record-value text-decoration-none">
                  {t('crm.lead')}
                </Link>
              ) : (
                <div className="crm-record-value">-</div>
              )}
            </Field>
            <Field label={t('timeline.createdBy')} value={personName(taskData?.created_by)} />
            <Field label={t('timeline.modifiedBy')} value={personName(taskData?.updated_by)} />
            <Field
              label={t('common.date')}
              value={taskData?.created_at ? formatDateTime(taskData.created_at) : null}
            />
            <Field label={t('common.description')} value={taskData?.description} lg="12" />
          </Row>
        </CardBody>
      </SectionCard>

      <NotesSection objectData={taskData} objectType="task" />

      <AttachmentsSection objectData={taskData} objectType="task" />
    </Fragment>
  );
}

export default OverviewTab;
